	/*
* Dynamically adds required asterisk around contact form required tags
* and adds listener to hide asterisk when dirty and return when clean
*/

(function($){
	var position_asterisks = function(){
		//adapted from: http://stackoverflow.com/questions/1582534/calculating-text-width-with-jquery
		//used to calculate width in pixels of placeholder text
		var calculate_text_width = function(text, font_size){
			var text_calc = '<span ' + 'style="font-size:' + font_size + ';">' + text + '</span>';
  			var text_calc_element = $(text_calc);
  			text_calc_element.hide().appendTo(document.body);
  			return text_calc_element.width();
		}
		var placeholder_text_font_size_px = 18;
		$('.required_asterisk').each(function(index, el) {
			var asterisk = $(this);
			var parent_input = asterisk.parent().find('.wpcf7-validates-as-required').first();
			var placeholder_text = parent_input.attr('placeholder');
			var parent_width = parent_input.outerWidth() - parent_input.css('padding-left').replace('px', '');
			var text_width = calculate_text_width(placeholder_text, placeholder_text_font_size_px + 'px');
			var asterisk_margin_left = (parent_width - text_width * 1.2) * -1;
			
			asterisk.css('margin-left', asterisk_margin_left + 'px');
		});
	};

	$(document).ready(function() {
		$('.wpcf7-validates-as-required').after('<span class="required_asterisk">* Required</span>');
		position_asterisks();
	});

	$(window).resize(function() {
		position_asterisks();
	});

	$('.wpcf7-form-control').keyup(function(event) {
		var input = $(this);
		if(input.val().length > 0){
			input.siblings('.required_asterisk').addClass('dirty');
		}
		else{
			input.siblings('.required_asterisk').removeClass('dirty');
		}
	});
})(jQuery);